// @flow
import React from 'react'
import PRMetaData from '../../../components/pull_request/Header/PRMetaData'

type Props = {
  model: Object,
  currentAccount: Object
}

export default class PRMetaDataContainer extends React.Component<Props> {
  render () {
    const model = this.props.model
    const props = {
      model,
      currentAccount: this.props.currentAccount,
      defaultBranch: model.get('default_branch'),
      branchName: model.get('branch_name')
    }
    return (
      <PRMetaData {...props} />
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/pull_request/Header/PRMetaDataContainer.js